import React from 'react';
import { sosStyle, dnStyle } from '../sosHeat';

const NoData = () => (
    <span className="inline-flex items-center gap-1.5">
        <span className="text-surface-300">—</span>
        sin datos
    </span>
);

/**
 * Share-of-Shelf legend: the continuous pink → yellow → green scale, anchored at 0%, 10% and 25%+.
 */
export function SosLegend() {
    const gradient = `linear-gradient(to right, ${sosStyle(0).bg} 0%, ${sosStyle(10).bg} 40%, ${sosStyle(25).bg} 100%)`;
    return (
        <span className="inline-flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-surface-500">
            <span className="inline-flex items-center gap-2">
                Share
                <span className="inline-flex w-36 flex-col gap-0.5">
                    <span className="h-2.5 rounded-full border border-surface-200" style={{ background: gradient }} />
                    <span className="relative h-3 text-[10px] leading-3 tabular-nums text-surface-400">
                        <span className="absolute left-0">0%</span>
                        <span className="absolute -translate-x-1/2" style={{ left: '40%' }}>
                            10%
                        </span>
                        <span className="absolute right-0">25%+</span>
                    </span>
                </span>
            </span>
            <NoData />
        </span>
    );
}

const DN_BANDS = [
    { label: '< 80%', pct: 50 },
    { label: '80–90%', pct: 85 },
    { label: '≥ 90%', pct: 95 }
];

/** Distribución Numérica legend: three discrete bands. */
export function DnLegend() {
    return (
        <span className="inline-flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-surface-500">
            {DN_BANDS.map((b) => (
                <span key={b.label} className="inline-flex items-center gap-1.5 tabular-nums">
                    <span className="h-3 w-3 rounded-sm border border-surface-200" style={{ background: dnStyle(b.pct).bg }} />
                    {b.label}
                </span>
            ))}
            <NoData />
        </span>
    );
}
